import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';

import { UserService } from 'app/services/user.service';

import { EmptyStateCardComponent } from 'app/components/distinct-components/cards/empty-state-card/empty-state-card.component';
import { PageWrapperComponent } from 'app/components/ui-kit/page-components/page-wrapper/page-wrapper.component';
import { FlightConnectionsService } from 'app/services/flight-connections-services';
import { ActivatedRoute, Router } from '@angular/router';
import { TabBarComponent } from "../../../components/ui-kit/tab/tab-bar/tab-bar.component";
import { FlightConnectionCardComponent } from "../../../components/distinct-components/cards/flight-connection-card/flight-connection-card.component";
import { AppStateService } from 'app/services/app-state.service';
import { FlightOptionService } from 'app/services/flight-option-service';
@Component({
  selector: 'app-connections',
  standalone: true,
  imports: [CommonModule, PageWrapperComponent, EmptyStateCardComponent, TabBarComponent, FlightConnectionCardComponent],
  templateUrl: './connections.component.html',
  styleUrl: './connections.component.scss'
})
export class ConnectionsComponent {
  isLoading: boolean = true;
  connections: any = [];
  pendingConnections: any = [];
  confirmedConnections: any = [];
  upcomingConnections: any = [];
  pastConnections: any = [];

  
  tabView: string = 'connected flights';
  connectionTabs: any = [
    { iconURL: '/assets/svg/flight-shape-solid.svg', iconSize: '22px', label: 'Connected Flights', showIndicator: false, onClick: () => this.onClickShowConfirmed()},
    { iconURL: '/assets/svg/inbox-solid.svg', iconSize: '22px', label: 'Requests', showIndicator: false, onClick: () => this.onClickShowPending()}
  ]

  constructor(private connectionsService: FlightConnectionsService, private userService: UserService,
    private router: Router, private route: ActivatedRoute, private appState: AppStateService,
    private flightOptionService: FlightOptionService) { }

  ngOnInit(): void {
    this.loadWatcherData();
    this.route.queryParams.subscribe(params => {
      const tab = params['tab'];
      if (tab) {
        this.tabView = tab;
      }
    });
  }

  async loadWatcherData() {
    const user = await this.userService.getUserProfile();

    try {
      const connections = await this.connectionsService.getConnectionByUserId(user.id);
      this.connections = connections;
      const currentUser = await this.userService.getUserProfile();
      const pending = connections.filter((c) => c.status === 'pending' && c.toId === currentUser.id);
      const confirmed = connections.filter((c) => c.status === 'accepted');

      this.pendingConnections = pending;
      this.confirmedConnections = confirmed;

      const enriched = await Promise.all(confirmed.map(async c => {
        try {
          const optionId = c.toUserFlightOptionId || c.fromUserFlightOptionId;
          const flight = optionId ? await this.flightOptionService.getFlightOption(optionId) : null;
          c.flightOption = flight;
        } catch (err) {
          console.error('error loading flight option', err);
        }
        return c;
      }));

      const today = new Date();
      today.setHours(0,0,0,0);
      this.upcomingConnections = [];
      this.pastConnections = [];
      for (const c of enriched) {
        const endStr = c.flightOption?.departureDateRangeEnd || c.flightOption?.departureDateExact;
        if (endStr) {
          const endDate = new Date(endStr);
          endDate.setHours(23,59,59,999);
          if (endDate < today) {
            this.pastConnections.push(c);
            continue;
          }
        }
        this.upcomingConnections.push(c);
      }

      if (pending.length > 0) {
        const pendingIndex = this.connectionTabs.findIndex((t) => t.label === 'Requests');
        this.connectionTabs[pendingIndex].showIndicator = true;
      }
    } catch (err) {
      console.error(err);
      // TODO: Error handling
    } finally {
      this.isLoading = false;
      setTimeout(() => {
        this.animatePage();
        this.animateResults();
      }, 100);
    }
  }

  animatePage() {
    anime({
      targets: '#page',
      duration: 650,
      opacity: [0, 1],
      translateY: [12, 0],
      easing: 'spring(1, 80, 10, 2)',
      loop: false,
    });
  }

  animateResults() {
    anime({
      targets: '#c-card',
      duration: 650,
      opacity: [0, 1],
      translateY: [12, 0],
      delay: anime.stagger(75),
      direction: 'alternate',
      easing: 'spring(1, 80, 10, 2)',
      loop: false,
    });
  }

  onClickShowConfirmed() {
    this.tabView = 'connected flights'
  }

  onClickShowPending() {
  this.tabView = 'requests'
  }

  onClickConnection(connectionObj): void {
    this.router.navigate(['/connection', connectionObj.id]);
  }
}
